import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowUpdateArchiveModal = createSelector(
  [(store: RootState) => store.documentShow.showUpdateArchiveModal],
  (data) => data
);
